import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, computed } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {  Subject, takeUntil } from 'rxjs';
import { AppStateService } from '../../services/app-state.service';
import { ThemeService } from '../../services/theme.service';
import { UserwaySettingsService } from '../../services/userway-settings.service';

@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterModule],
  templateUrl: './footer.component.html',
})
export class FooterComponent implements OnInit, OnDestroy{
  contact: any;
  isDarkMode: boolean = false;
  linkSections: { title: string; links: { name: string; url: string; label?: string }[] }[] = [];
  socialLinks: { icon: string; url: string }[] = [];
  copyright: string = '';
  privacyPolicy: string = '';
  year = new Date().getFullYear();
  isLearnerPage = computed(() => this.appStateService.userRole() === 'learner');
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly themeService: ThemeService, 
    public readonly appStateService: AppStateService,
    public readonly userwaySettings: UserwaySettingsService) { }

  ngOnInit(): void {
    const footerData = {
      contact: {
        phone: "+91 9281 011895",
        tablet: "+91 9000 123456",
        email: "contact@youth4jobs.org",
        address:
          "Plot no: 4, 8-2-686/D/1/G/4, Kanchi Thatti Khana Road No. 12, Banjara Hills, Hyderabad-500034, Telangana, India."
      },
      linkSections: [
        {
          title: "Resources",
          links: [
            { name: "Blogs", url: "/blogs" },
            { name: "Programs", url: "/programs" },
            { name: "FAQ", url: "/faq" }
          ]
        },
        {
          title: "Information",
          links: [
            { name: "About US", label: "About us", url: "/about" },
            { name: "FAQ", url: "/faq" },
            { name: "Support", url: "/support" }
          ]
        },
        {
          title: "Quick Links",
          links: [
            { name: "Home", url: "/" },
            { name: "Courses", url: "home" },
            { name: "Profile", url: "home/profile" },
            { name: "Find a job", url: "/jobs" }
          ]
        }
      ],
      socialLinks: [
        { icon: 'ti ti-brand-facebook', url: 'https://facebook.com' },
        { icon: 'ti ti-brand-instagram', url: 'https://instagram.com' },
        { icon: 'ti ti-brand-x', url: 'https://x.com' },
        { icon: 'ti ti-brand-youtube', url: 'https://youtube.com' }
      ],
      copyright: `© ${this.year} Youth4jobs. All Rights Reserved.`,
      privacyPolicy: "/privacy-policy"
    };

    this.contact = footerData.contact;
    this.linkSections = footerData.linkSections;
    this.socialLinks = footerData.socialLinks;
    this.privacyPolicy = footerData.privacyPolicy;
    this.copyright = footerData.copyright;
  }

  subscribeToDarkMode() {
    this.themeService.isDarkMode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isDark: boolean) => {
        this.isDarkMode = isDark;
      });
  }

  get logoSrc(): string {
    if(this.isDarkMode) {
      return './assets/imgs/logo-dark.svg';
    } else {
      if(this.userwaySettings.isLightContrast()) return './assets/imgs/logo-dark.svg';
      return'./assets/imgs/logo-light.svg';
    }
  }

  getSocialPlatformName(iconClass: string): string {
    const platformMap: { [key: string]: string } = {
      'ti-brand-facebook': 'Facebook',
      'ti-brand-instagram': 'Instagram',
      'ti-brand-x': 'X (Twitter)',
      'ti-brand-youtube': 'YouTube',
      'ti-brand-linkedin': 'LinkedIn',
      'ti-brand-twitter': 'Twitter'
    };

    for (const [key, value] of Object.entries(platformMap)) {
      if (iconClass.includes(key)) {
        return value;
      }
    }
    return 'social media';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}